<template>
  <auth-frame :title="tr('User identification')">
    <form class="flex flex-col gap-4" novalidate @submit="$event => onFormSubmit($event)">
      <div class="flex flex-col gap-1.5">
        <ui-label for="support-user-id">{{ tr('User ID') }}</ui-label>
        <ui-input
          id="support-user-id"
          v-model="userId"
          placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
          maxlength="36"
          autofocus
          :disabled="isLoading"
        />
      </div>

      <ui-button
        type="submit"
        size="lg"
        class="mt-2 w-full"
        :disabled="isLoading"
      >
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Login') }}
      </ui-button>
    </form>

    <ui-button variant="ghost" class="mx-auto mt-4 flex" @click="() => logout()">
      <log-out-icon />
      {{ tr('Log out') }}
    </ui-button>
  </auth-frame>
</template>

<script>
import { LoaderCircle, LogOut } from '@lucide/vue';

import AuthFrame from '@/ui/components/AuthFrame.vue';

export default {
  name: 'SupportMasqueradeView',
  components: {
    AuthFrame,
    LoaderCircleIcon: LoaderCircle,
    LogOutIcon: LogOut,
  },
  data() {
    return {
      isLoading: false,
      userId: '',
    };
  },
  created() {
    if (this.$root.isLoggedIn) {
      this.$store.dispatch('auth/logout');
    }

    const userId = this.$store.getters['support/autoLoginUserId'];
    if (userId) {
      this.userId = userId;
      this.onFormSubmit();
      this.$store.commit('support/setAutoLoginUserId', null);
    }
  },
  methods: {
    resetForm() {
      this.userId = '';
    },
    onFormSubmit($event) {
      if ($event) {
        $event.preventDefault();
      }

      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      this.$store.dispatch('support/masquerade', this.userId)
        .then(resp => {
          this.$store.commit('auth/setToken', resp.access_token);

          this.$root.fetchUserData();
          this.$router.replace({ path: '/dashboard' });

          this.$nextTick(() => this.resetForm());

          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => this.isLoading = false);
    },
    validate() {
      this.$toast.clear();

      if (this.userId.length !== 36) {
        this.$toast.error(this.tr('Invalid User ID.'));
        return false;
      }

      return true;
    },
    logout() {
      this.$store.dispatch('support/logout');
    },
  },
};
</script>
